import React, { useState, useEffect } from "react";
import { AppBar, Toolbar } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import styles from "./Navbar.module.css";
import Home from "../../assets/Home Button.svg";
import Dashboard from "../../assets/Dashboards.svg";
import DashboardLight from "../../assets/DashboardsLight.svg";
import Attainment from "../../assets/Attainment.svg";
import AttainmentLight from "../../assets/AttainmentLight.svg";
import Reports from "../../assets/Reports.svg";
import ReportsLight from "../../assets/ReportsLight.svg";
import Survey from "../../assets/Survey.svg";
import SurveyLight from "../../assets/SurveyLight.svg";
import Faculty from "../../assets/Faculty.svg";
import FacultyLight from "../../assets/FacultyLight.svg";
import Utilities from "../../assets/Utilities.svg";
import UtilitiesLight from "../../assets/UtilitiesLight.svg";
import Assessments from "../../assets/Assessments.svg";
import AssessmentsLight from "../../assets/AssessmentsLight.svg";
import Curriculum from "../../assets/Curriculum.svg";
import CurriculumLight from "../../assets/CurriculumLight.svg";
import { Link,withRouter } from "react-router-dom";
import {connect} from "react-redux";

const Navbar = (props) => {
  const [value, setValue] = useState(0);
  const params=props.location?.pathname;
  const handleChange = (e, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (params=== "/home") {
      setValue(0);
    } else if (params==="/dashboard") {
      setValue(1);
    } else if (params.includes("/attainment")) {
      setValue(2);
    } else if (params.includes("/reports")) {
      setValue(3);
    } else if (params.includes("/configuration")) {
      setValue(4);
    } else if (params.includes("/survey")) {
      setValue(5);
    } else if (
      params.includes("/faculty-contribution")) {
      setValue(6);
    } else if (params.includes("/utilities")) {
      setValue(7);
    } else if (params.includes("/assessments")) {
      setValue(8);
    } else if (params.includes("/curriculum")) {
      setValue(9);
    }
  }, [params]);
    const {auth} = props.user;
  return (
    <>
      {auth?<AppBar className={styles.appbar} position="fixed">
        <Toolbar className={styles.toolbar} disableGutters>
          <Tabs
            style={{ margin: 0 }}
            value={value}
            variant="scrollable"
            scrollButtons="auto"
            onChange={handleChange}
            aria-label="scrollable auto tabs example"
            TabIndicatorProps={{ style: { background: "transparent" } }}
            style={{ margin: "0", padding: "0" }}
          >
            {/* <Tab
              component={Link}
              to="/home"
              style={{ margin: 0, padding: 0 }}
              disableRipple
              label="Home"
              onClick={(e) => setValue(0)}
              icon={
                value == 0 ? (
                  <img src={Home} alt="Home" />
                ) : (
                  <img src={HomeLight} alt="Home" />
                )
              }
              className={value == 0 ? styles.active : undefined}
              style={{ margin: "0", padding: "0" }}
            /> */}
            <Tab
              component={Link}
              to="/dashboard"
              disableRipple
              label="Dashboard"
              onClick={(e) => setValue(1)}
              icon={
                value == 1 ? (
                  <img src={Dashboard} alt="Dashboard" />
                ) : (
                  <img src={DashboardLight} alt="Dashboard" />
                )
              }
              className={value == 1 ? styles.active : undefined}
              style={{ margin: "0", padding: "0" }}
            />
            <Tab
              component={Link}
              to="/attainment"
              label="Attainment"
              disableRipple
              onClick={(e) => setValue(2)}
              icon={
                value == 2 ? (
                  <img src={Attainment} alt="Attainment" />
                ) : (
                  <img src={AttainmentLight} alt="Attainment" />
                )
              }
              className={value == 2 ? styles.active : undefined}
              style={{ margin: "0", padding: "0" }}
            />
            <Tab
              component={Link}
              to="/reports"
              disableRipple
              label="Reports"
              onClick={(e) => setValue(3)}
              icon={
                value == 3 ? (
                  <img src={Reports} alt="Reports" />
                ) : (
                  <img src={ReportsLight} alt="Reports" />
                )
              }
              className={value == 3 ? styles.active : undefined}
              style={{ margin: "0", padding: "0" }}
            />
            <Tab
              component={Link}
              to="/configuration"
              disableRipple
              label="Configuration"
              onClick={(e) => setValue(4)}
              icon={
                value == 4 ? (
                  <img src={Attainment} alt="Configuration" />
                ) : (
                  <img src={AttainmentLight} alt="Configuration" />
                )
              }
              className={value == 4 ? styles.active : undefined}
              style={{ margin: "0", padding: "0" }}
            />

            <Tab
              component={Link}
              to="/survey"
              disableRipple
              label="Survey"
              onClick={(e) => setValue(5)}
              icon={
                value == 5 ? (
                  <img src={Survey} alt="Survey" />
                ) : (
                  <img src={SurveyLight} alt="Survey" />
                )
              }
              className={value == 5 ? styles.active : undefined}
              style={{ margin: "0", padding: "0" }}
            />
            <Tab
              component={Link}
              to="/faculty-contribution"
              disableRipple
              label="Faculty Contribution"
              onClick={(e) => setValue(6)}
              icon={
                value == 6 ? (
                  <img src={Faculty} alt="Faculty Contribution" />
                ) : (
                  <img src={FacultyLight} alt="Faculty Contribution" />
                )
              }
              className={value == 6 ? styles.active : undefined}
            />
            <Tab
              component={Link}
              to="/utilities"
              disableRipple
              label="Utilities"
              onClick={(e) => setValue(7)}
              icon={
                value == 7 ? (
                  <img src={Utilities} alt="Utilities" />
                ) : (
                  <img src={UtilitiesLight} alt="Utilities" />
                )
              }
              className={value == 7 ? styles.active : undefined}
            />
            <Tab
              component={Link}
              to="/assessments"
              disableRipple
              label="Assessments"
              onClick={(e) => setValue(8)}
              icon={
                value == 8 ? (
                  <img src={Assessments} alt="Assessments" />
                ) : (
                  <img src={AssessmentsLight} alt="Assessments" />
                )
              }
              className={value == 8 ? styles.active : undefined}
            />
            <Tab
              component={Link}
              to="/curriculum"
              disableRipple
              label="Curriculum"
              onClick={(e) => setValue(9)}
              icon={
                value == 9 ? (
                  <img src={Curriculum} alt="Curriculum" />
                ) : (
                  <img src={CurriculumLight} alt="Curriculum" />
                )
              }
              className={value == 9 ? styles.active : undefined}
            />
            
          </Tabs>
        </Toolbar>
      </AppBar>:''}
    </>
  );
};
const mapStateWithProps = (state)=>(
     { user : state.user}
)
export default connect(mapStateWithProps)(withRouter(Navbar));
